define(['jquery', 'c21/track', 'c21/results'], function ($, track, results) {
   "use strict";

   /**
    * Manages the paginator butttons that appear at the bottom of the map
    */
   return function () {
      var self = this,
         m_jMapTools = $("#mapToolsArea"),
         m_jBtnPrev = m_jMapTools.find(".prevBtn"),
         m_jBtnNext = m_jMapTools.find(".nextBtn"),
         m_iCurrentPage = 0,

         initPaginatorButtons = function () {
            m_jBtnNext.off(".paginator").on("click.paginator", function () {
               if (m_jBtnNext.hasClass('disabled')) {
                  return;
               }
               track.doEvent('Hybrid Mapping', 'Tool Bar', 'Select next button map paginator');
               results.setResultStart(m_iCurrentPage + 1);
            });

            m_jBtnPrev.off(".paginator").on("click.paginator", function () {
               if (m_jBtnPrev.hasClass('disabled')) {
                  return;
               }
               track.doEvent('Hybrid Mapping', 'Tool Bar', 'Select previous button map paginator');
               results.setResultStart(m_iCurrentPage - 1);
            });
         };

      initPaginatorButtons();

      self.updatePaginatorButtons = function (iCurrentPage, iMaxPage) {
         m_iCurrentPage = iCurrentPage;

         if (m_iCurrentPage === iMaxPage) {
            m_jBtnNext.addClass('disabled');
         } else {
            m_jBtnNext.removeClass('disabled');
         }

         // If this is the first page, or there are no results
         if ((m_iCurrentPage === 1) || (m_iCurrentPage === undefined)) {
            m_jBtnPrev.addClass('disabled');
         } else {
            m_jBtnPrev.removeClass('disabled');
         }
      };
   };
});
